import { OfficialFormatDateWithYear } from '../../utilities/FormatDate';
import { ConvertToGrams } from '../../utilities/Converter';
import { useContext } from 'react';
import { PatientContext } from '../../data_layer/context/Patient/PatientContext';
import { WeeksBetweenDates } from '../../utilities/WeeksBetweenDates';


function BiomarkersTable({ data, conceptionDate }) {

  const {getCurrentFeedingWithoutPatientId} = useContext(PatientContext);

  const timestamp = getCurrentFeedingWithoutPatientId();

  return (
    <table className="biomarkers-table w-100">
      <thead>
        <tr className={`border-b border-color-gray border-bottom-width-table`}>
          <th className="border-e border-color-gray border-right-width-table">Date</th>
          <th>Conceptual Age</th>
          { 
            data?.[0]?.biomarkers?.map(b => (<th key={b.abv}>{ b.abv }</th>))
          }
          <th>Weight</th>
          <th>Volume</th>
        </tr>
      </thead>
      <tbody>
        {
          data?.map((row, index) => (
            <tr className={`border-b border-color-gray-100 border-bottom-width-table ${row.timestamp === timestamp && "bg-light-gray"}`} key={index}>
              <td className="border-e border-color-gray border-right-width-table">{OfficialFormatDateWithYear(row.timestamp)}</td>
              <td>{ conceptionDate ? `${WeeksBetweenDates(conceptionDate, row.timestamp)} weeks` : '--'}</td>

              { 
                row.biomarkers?.map(b => (<td key={b.id}>{ b.value || 0}</td>))
              }

              <td>{ row.weight && row.weight_uom ? `${ConvertToGrams(row.weight, row.weight_uom)} g` : '--'}</td>
              <td>{ row.consumption && row.consumption_uom ? `${row.consumption} ${row.consumption_uom}` : '--'}</td>
            </tr>
          ))
        }

      </tbody>
    </table>
  )
}

export default BiomarkersTable;